import React, { useEffect, useState } from "react";
import { FiChevronDown, FiMessageSquare } from "react-icons/fi";
import CustomModal from "./CustomModal";
import ChatComponent from "../chat/ChatComponent";
import { useSelector, useDispatch } from "react-redux";
import { setChatModalOpen } from "../Slices/ChatSlice";
import Draggable from "react-draggable";

const ChatIconButton = () => {
  const dispatch = useDispatch();
  const isChatModalOpen = useSelector(
    (state) => state.conversation.isChatModalOpen
  );

  const conversationsData = useSelector(
    (state) => state.conversation.withMessagesConversations || []
  );

  const groupsConversationsData = useSelector(
    (state) => state.conversation.withMessagesGroups || []
  );

  const totalUnreadCount = conversationsData?.reduce(
    (total, conversation) => total + (conversation?.unreadCount || 0),
    0
  );

  const totalUnreadCountGroups = groupsConversationsData?.reduce(
    (total, conversation) => total + (conversation?.unreadCount || 0),
    0
  );

  const combineUnredCount = totalUnreadCount + totalUnreadCountGroups;

  const [prevUnreadCount, setPrevUnreadCount] = useState(combineUnredCount);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartPosition, setDragStartPosition] = useState(null);

  useEffect(() => {
    if (combineUnredCount !== prevUnreadCount) {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 500);
      setPrevUnreadCount(combineUnredCount);
    }
  }, [combineUnredCount, prevUnreadCount]);

  useEffect(() => {
    if (combineUnredCount > 0) {
      document.title = `(${combineUnredCount > 99 ? "99+" : combineUnredCount}) Support Portal`;
    } else {
      document.title = "Support Portal";
    }
  }, [combineUnredCount]);

  const toggleChatModal = () => {
    if (!isDragging) {
      dispatch(setChatModalOpen(!isChatModalOpen));
    }
  };

  return (
    <>
      <Draggable
        axis="y"
        bounds="parent"
        onStart={(e, data) => {
          setIsDragging(false);
          setDragStartPosition({ x: data.x, y: data.y });
        }}
        onDrag={(e, data) => {
          if (
            dragStartPosition &&
            (Math.abs(data.x - dragStartPosition.x) > 5 ||
              Math.abs(data.y - dragStartPosition.y) > 5)
          ) {
            setIsDragging(true);
          }
        }}
        onStop={() => {
          setTimeout(() => setIsDragging(false), 100);
          setDragStartPosition(null);
        }}
      >
        <button
          className="fixed bottom-0 right-4 bg-blue-400 text-white p-3 3xl:p-4 rounded-full shadow-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 z-40 mb-4 mt-20"
          aria-label="Chat"
          onClick={toggleChatModal}
          title="Drag to move"
        >
          {isChatModalOpen ? (
            <FiChevronDown className="h-8 w-8" />
          ) : (
            <FiMessageSquare className="h-8 w-8" />
          )}

          {combineUnredCount > 0 && !isChatModalOpen && (
            <span
              className={`absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center ${
                isAnimating ? "animate-bounce" : ""
              }`}
            >
              {combineUnredCount > 99 ? "99+" : combineUnredCount}
            </span>
          )}
        </button>
      </Draggable>

      {isChatModalOpen && (
        <CustomModal
          isLoading={false}
          title="Chat"
          size="chat"
          ModalBody={<ChatComponent />}
          onClose={toggleChatModal}
        />
      )}
    </>
  );
};

export default ChatIconButton;
